import {
	//Box,
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography
} from "@mui/material"
import {useDispatch} from "react-redux"
import {
	//inviteNewWorkspaceMember,
	MANAGE_WORKSPACE_VIEW,
	setIsAddingNewMember,
	setManageWorkspaceView,
	setTargetUser
} from "../../reducers/manageWorkspaceSlice"
import {ManageModalContainer} from "./shared_components/ManageModalContainer"
import {UserLookup, LookupTypes} from "../../utils/UserLookup"
//import {useSnackbar} from "notistack"

export function UserLookupPanel() {
	const dispatch = useDispatch()
	//const {enqueueSnackbar} = useSnackbar()

	const handleClick = (user) => {
		// dispatch(inviteNewWorkspaceMember(user))
		// enqueueSnackbar("An invite has been sent to this user.", {variant: "success"})
		// dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.MANAGE_MEMBERS))

		const newWorkspaceMemberDTO = {
			user,
			workspacePermissions: {
				read: true,
				write: false,
				admin: false,
			},
			selectedNoteIds: {}
		}
		dispatch(setIsAddingNewMember(true))
		dispatch(setTargetUser(newWorkspaceMemberDTO))
		dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.MANAGE_MEMBER))
	}

	return (
		<ManageModalContainer>
			<DialogTitle>Find a User</DialogTitle>
			<DialogContent sx={{margin: "20px 10px", overflowY: "visible"}}>
				<Typography paragraph variant={"tunedH3"} sx={{ color: "rgb(85,85,85)"}}>
					Search for an existing Refzoom user to invite to this workspace:
				</Typography>
				<UserLookup
					lookupType={LookupTypes.NON_WORKSPACE_MEMBERS}
					onSelectUserCB={(user) => {handleClick(user)}}
					//controlScroll={false}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					variant={"outlined"}
					color={"error"}
					onClick={() => dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.MANAGE_MEMBERS))}
				>
					Cancel
				</Button>
			</DialogActions>
		</ManageModalContainer>
	)
}